import { defineStore } from "pinia";

export const useRoleStore = defineStore({
  id: "roleStore", //ストアの識別子

  persist: true, //このストアの状態を永続化する

  //状態を定義
  state: () => ({
    role: [],
  }),

  //状態を変更するためのアクション
  actions: {
    setRole(value) {
      this.role = value;
    },
  },

  //状態から派生した値を取得するためのゲッター
  getters: {
    getRole() {
      return this.role;
    },
  },
});

/*
//ストアを使用するためのピニアのインスタンスを作成します
export const pinia = createPinia();

pinia.use(
  createPersistedState({
    storage: window.sessionStorage,
    paths: ['role'], // 保存したい状態を配列として指定
  })
);*/
